import { ColumnDefinition } from 'components/Grid/types';
import { basicAssetsColumns } from 'containers/Assets/components/AssetsTable/AssetsTable';
import { basicDocumentsColumns } from 'containers/Documents/components/basicDocumentColumns';
import { basicEventsColumns } from 'containers/Events/components/EventsTable/EventsTable';
import { basicRiskAssessmentsColumns } from 'containers/RiskAssessments/components/RiskAssessmentsTable/RiskAssessmentsTable';
import { basicSiteColumns } from 'containers/Sites/components/SitesTable/SitesTable';
import { basicContactsColumns } from 'containers/Contacts/components/ContactsTable/ContactsTable';
import { basicRisksColumns } from 'containers/Risks/components/RisksTable/RisksTable';
import { EntityModules } from 'core/constants';

export const getBasicColumnsBasedOnEntity = (entity: EntityModules): ColumnDefinition[] => {
  let exhaustiveCheck: never;

  switch (entity) {
    case EntityModules.Sites:
      return basicSiteColumns;
    case EntityModules.Assets:
      return basicAssetsColumns;
    case EntityModules.Contacts:
      return basicContactsColumns;
    case EntityModules.Events:
      return basicEventsColumns;
    case EntityModules.RisksAssessments:
      return basicRiskAssessmentsColumns;
    case EntityModules.Documents:
      return basicDocumentsColumns;
    case EntityModules.Risks:
      return basicRisksColumns;
    case EntityModules.Audits:
    case EntityModules.Controls:
    case EntityModules.Hazards:
      return [];
    default:
      // This will cause a TypeScript error if a new EntityModule is added but not handled
      exhaustiveCheck = entity;
      return [];
  }
};
